module.exports = __webpack_public_path__ + "media/assets/images/tour/3_Tour_3-00b057290b50aeea5db7412761ef3ea6.png";